import React from "react";
import {Box, Flex, Spacer, Text, VStack} from "@chakra-ui/react";
import Card from "components/card/Card";
import {BsCircleFill, BsStar} from "react-icons/bs";
import {gql, useQuery} from "@apollo/client";
import Highlighter from "react-highlight-words";
import {platformToPlatformName} from "variables/constants";
import {indexColorMap} from "./SentimentSelectorButton";

const getTextsByAspectSentiment = gql`
query GetTextsByAspectSentiment($product_ids: [String!] = "", $aspect: String = "product", 
$sentiment1: String_comparison_exp = {_eq: "positive"}, $start_date: timestamp ="1900-01-01", $end_date: timestamp = "2100-01-01") {
  texts(where: {aspect_sentiments: {sentiment: $sentiment1, aspect: {_eq: $aspect}}, product_platform_id: {_in: $product_ids},
   timestamp_original: {_gte: $start_date, _lte: $end_date}}, order_by: {timestamp_original: desc}) {
    text_id
    text
    data
    timestamp_original
    product {
      platform
    }
    aspect_sentiments(where: {aspect: {_eq: $aspect}}) {
      sentiment
    }
  }
}
`
export const monthToText = {
    0: "January",
    1: "February",
    2: "March",
    3: "April",
    4: "May",
    5: "June",
    6: "July",
    7: "August",
    8: "September",
    9: "October",
    10: "November",
    11: "December"
}
export default function ReviewReader(props) {
    const {renderReviews, product_ids, aspect, sentiment, startDate, endDate} = props;
    const marginLeft = "15px"
    const dummyIndex = {"positive": 0, "neutral": 1, "negative": 2}
    let {loading, error, data} = useQuery(getTextsByAspectSentiment,
        {
            variables: {
                "product_ids": product_ids,
                "sentiment1": (sentiment === "all" ? {"_in": ["positive", "negative", "neutral"]} : {"_eq": sentiment}),
                "aspect": aspect,
                "start_date": startDate,
                "end_date": endDate
            },
            skip: !renderReviews
        }
    )
    if (!renderReviews) {
        return <Card ml={marginLeft}><Text>See Reviews here by selecting the aspect above</Text></Card>
    }
    if (error) console.log("Error ", error);
    let reviews;
    if (loading) {
        reviews = <Text>Loading Reviews...</Text>
    } else if (data.texts.length === 0) {
        reviews = <Text>No {sentiment} reviews found</Text>
    } else {
        reviews = data.texts.map((t, index) => {
            const d = new Date(t.timestamp_original);
            return <>
                <Box bgColor="#EEEEEE" key={index.toString() + "sdflksgsg"} px="6px">
                    <Flex verticalAlign="bottom" alignItems="center"><BsStar/><Text
                        fontWeight="bold">{t.data.review_rating}</Text>
                        {sentiment === "all" ? <BsCircleFill style={{
                            color: indexColorMap[dummyIndex[t.aspect_sentiments[0].sentiment]],
                            size: "0.8em",
                            height: "0.8em",
                            width: "0.8em",
                            marginLeft: "10px"
                        }}/> : null}
                        <Spacer/>
                        <Text> {(platformToPlatformName[t.product.platform] ?? "") + ' — '}</Text>
                        <Text
                            fontWeight="bold">{' ' + d.getDate() + ' ' + monthToText[d.getMonth()] + ' ' + d.getFullYear()}
                        </Text>
                    </Flex>
                </Box>
                <Box
                    key={index.toString() + "rdflksgsg"}>
                    <Highlighter searchWords={["\\b" + aspect + "\\b"]}
                                 highlightStyle={{
                                     "background-color": "rgba(75, 124, 248, 0.25)",
                                     "border-radius": "5px",
                                     "padding": "0px 3px"
                                 }}
                                 textToHighlight={t.text}/>
                </Box>
            </>

        })
    }
    return (
        <Box ml="45px">
            <VStack spacing={2} mt="20px"
                    align="stretch">
                {reviews}
            </VStack>
        </Box>
    )
}